export default __webpack_public_path__ + "src/images/packages/villa-one-hilltop/376fff551013b787d2f81bede439245b-2.jpg";